/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Typography } from '@mui/material';
import React, { useState } from 'react';
import moment from 'moment';
import { useAppDispatch } from '../../../infra/hooks';
import {
  setARValueFromDate,
  setARValueToDate,
} from '../../../infra/aggregates/actionRequired/actionRequiredSlice';
import { DatePickerInput } from '../../../components';
import { baseDateTimeFormatting } from '../../helper';

const TwoDatesFilter = () => {
  const [fromDate, setFromDate] = useState(
    moment(new Date()).subtract('days', 15).format(baseDateTimeFormatting),
  );
  const [toDate, setToDate] = useState(
    moment(new Date()).add('day', 1).format(baseDateTimeFormatting),
  );
  const dispatch = useAppDispatch();
  const handleFromDateChange = (date: any) => {
    dispatch(setARValueFromDate(date));

    setFromDate(date);
  };
  const handleToDateChange = (date: any) => {
    dispatch(setARValueToDate(date));
    setToDate(date);
  };

  return (
    <Box
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '12px',
        borderRadius: '5px',
        backgroundColor: '#f5f5fa',
      }}
    >
      <DatePickerInput
        onChange={handleFromDateChange}
        defaultValue={fromDate}
        size="small"
        fontSize="14px"
        width="130px"
        variant="standard"
      />
      <Box
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        <Typography
          style={{
            color: '#7C0E6F',
            fontSize: '0.8em',
            fontWeight: 'bold',
            padding: '0 15px',
          }}
        >
          -
        </Typography>
      </Box>

      <DatePickerInput
        onChange={handleToDateChange}
        defaultValue={toDate}
        size="small"
        width="130px"
        fontSize="14px"
        variant="standard"
      />
    </Box>
  );
};

export default TwoDatesFilter;
